<template>
  <div class="cardAverbacao mx-2">
    <h2 class="cardAverbacao_title mb-3"
        :class="showCollapse ? 'collapsed' : null"
        :aria-expanded="showCollapse ? 'true' : 'false'"
        :aria-controls="`collapse--${idRegistro}`"
        @click="showCollapse = !showCollapse">
      Averbações <span class="small">{{ !!averbacoes.length ? averbacoes.length : '0' }} nesse registro</span>
    </h2>
    <b-collapse :id="`collapse--${idRegistro}`"
                v-model="showCollapse">
      <div v-for="item in averbacoes"
           :key="item.documento_id"
           class="cardAverbacao_content mb-3">
        <div class="cardAverbacao_header d-flex justify-content-between align-items-center">
          <svg v-if="item.origem && item.origem === 'SOFIA_GED'"
               class="icon--sm gedIcon"
               role="presentation">
            <use :xlink:href="'#' + gedIcon.id" />
          </svg>
          <span class="cardAverbacao_header_title d-inline-block">{{ item.data_averbacao | date }}</span>
          <div class="d-flex d-inline justify-content-between">
            <p class="flag-averb"
               :class="{'flag-averb-disabled': !item.averb_acrescida_certidao}">
              Averbação acrescida na certidão
              <IconSvg v-if="item.averb_acrescida_certidao"
                       class="icon-done-averb"
                       icon="done" />
              <IconSvg v-else
                       class="icon-close-averb"
                       icon="close2" />
            </p>
            <p class="flag-averb"
               :class="{'flag-averb-disabled': !item.averb_impressa_livro}">
              Averbação impressa no livro
              <IconSvg v-if="item.averb_impressa_livro"
                       class="icon-done-averb"
                       icon="done" />
              <IconSvg v-else
                       class="icon-close-averb"
                       icon="close2" />
            </p>
            <p v-if="!!propTransporte"
               class="flag-averb"
               :class="{'flag-averb-disabled': !item.averb_impressa_transporte}">
              Averbação impressa no transporte
              <IconSvg v-if="item.averb_impressa_transporte"
                       class="icon-done-averb"
                       icon="done" />
              <IconSvg v-else
                       class="icon-close-averb"
                       icon="close2" />
            </p>
          </div>
          <div class="cardAverbacao_wrapIcons d-inline-block">
            <button class="cardAverbacao_wrapIcons_btn btn btn-sm btn-outline-dark mr-1"
                    title="Imprimir averbação"
                    type="button"
                    @click="sendToPrint(item)">
              <svg class="cardAverbacao_wrapIcons_icon icon--xxs"
                   role="presentation">
                <use :xlink:href="'#' + printer.id" />
              </svg>
            </button>

            <button v-if="!item.origem || (item.origem && item.origem !== 'SOFIA_GED')"
                    class="cardAverbacao_wrapIcons_btn btn btn-sm btn-danger mr-1"
                    title="Deletar averbação"
                    type="button"
                    @click="onClickExcluirAverbacao(item.documento_id)">
              <svg class="cardAverbacao_wrapIcons_icon--iconDelete icon--xxs"
                   role="presentation">
                <use :xlink:href="'#' + trash.id" />
              </svg>
            </button>

            <button class="cardAverbacao_wrapIcons_btn btn btn-sm btn-primary"
                    title="Editar averbação"
                    type="button"
                    @click="onClickEditarAverbacao(item)">
              <svg class="cardAverbacao_wrapIcons_icon--iconEdit icon--xxs"
                   role="presentation">
                <use :xlink:href="'#' + edit.id" />
              </svg>
            </button>
          </div>
        </div>

        <p class="cardAverbacao_content_text m-0">
          {{ item.texto_averbacao }}
        </p>
      </div>

      <AverbacaoBusca ref="formAverb"
                      :registro="idRegistro"
                      :averb="averb"
                      :prop-transporte="propTransporte"
                      @onUpdateAverb="updateAverb"
                      @onUpdateList="updateList" />
      <b-modal ref="modalCertificados"
               hide-footer
               title="Selecione um certificado"
               size="lg">
        <grid-certificados v-if="certificados && certificados.length > 0"
                           :certificados="certificados"
                           @onSelectCertificado="onSelectCertificado" />
      </b-modal>
    </b-collapse>
  </div>
</template>

<script>
  /* assetrs */
  import trash from '@/assets/icons/delete.svg?sprite'
  import printer from '@/assets/icons/print.svg?sprite'
  import edit from '@/assets/icons/pencil.svg?sprite'
  import gedIcon from '@/assets/icons/ged-temp.svg?sprite'

  /* components */
  import AverbacaoBusca from '@/components/SofiaRei/Busca/AverbacaoBusca.vue'
  import GridCertificados from './GridCertificados'

  /* services */
  import AverbacoesService from "@/services/Registros/AverbacoesService"
  import SofiaSignerService from "@/services/SofiaSignerService"
  import DocumentosService from "@/services/Documentos"
  import BryService from '@/services/Assinaturas/BryService'
  import ImpressaoService from '@/services/Registros/ImpressaoService'

  /* constants */
  import { IMPRIMIR_AVERBACOES, ADMIN } from "@/constants/permissions"

  /* outros */
  import {mapGetters} from "vuex"

  export default {
    name: "CardAverbacao",
    components: {
      AverbacaoBusca,
      GridCertificados
    },
    props: [ 'idRegistro', 'propTransporte' ],
    data () {
      return {
        printer,
        trash,
        edit,
        gedIcon,
        showCollapse: null,
        objPrinters: {},
        listPrinters: [],
        averb: null,
        certificados: null,
        certificadoSelecionado: null,
        averbacoes: [],
        docId: null,
        text: null,
        livroDeRegistro: null,
        crud: null,
        editTextoAverbacao: '',
        IMPRIMIR_AVERBACOES,
        ADMIN,
      }
    },
    computed: {
      ...mapGetters({
        user: 'auth/getUser'
      })
    },
    async mounted () {
      AverbacoesService.getAverbacaoByRegistroId(this.idRegistro.registro_id).then(res => this.averbacoes = res)

      const livroDeRegistro = await DocumentosService.getLivroDeRegistro(this.idRegistro.registro_id)

      if (livroDeRegistro) {
        this.livroDeRegistro = livroDeRegistro
      }
    },
    methods: {
      onClickEditarAverbacao (val) {
        let child = this.$refs.formAverb
        this.averb = { ...val }
        child.openForEdit()

        return this.averb
      },
      async sendToPrint (averbacao) {
        // Verificamos a permissão no método pois nenhuma rota é chamada
        // Se for suporte ou oficial não validamos
        const { groups, flag_oficial } = this.user

        let login = ''

        if (this.user) {
          login = this.user.login.split('_')[0]
        }

        if (groups && groups.length && !flag_oficial) {
          let access = false
          const permissions = [ this.IMPRIMIR_AVERBACOES, this.ADMIN]

          groups.forEach(group => {
            const permission = !!group.permissions.find(permission => !!permissions.includes(permission.codename))

            if (permission && group.ativo) access = true
          })

          if (!access) {
            return displayMessage('error', 'Acesso negado!', 'Você não tem permissão para acessar essa função.')
          }
        } else if (login !== 'suporte' && !flag_oficial) {
          return displayMessage('error', 'Acesso negado!', 'Você não tem permissão para acessar essa função.')
        }

        try {
          loader({active: true})
          const url = await ImpressaoService.etiqueta({ textoImpressao: averbacao.texto_averbacao })

          window.open(url)
        } catch (e) {
          displayMessage('error', 'Erro!', 'Não foi possível gerar o PDF da impressão')
        } finally {
          loader({active: false})
        }
      },
      updateAverb () {
        this.averb = null
      },
      updateList () {
        this.averb = null
        AverbacoesService.getAverbacaoByRegistroId(this.idRegistro.registro_id).then(res => this.averbacoes = res)
        this.$parent.$emit('onUpdateSearch')
      },
      async onClickExcluirAverbacao (averbacaoId) {
        this.averbacaoId = averbacaoId
        this.crud = 'destroy'

        const averbacao = this.averbacoes.find(averbacao => averbacao.documento_id === averbacaoId)

        if (!averbacao) return

        // Só chamamos o certificado existe o livro de registro e a averbação impressa no livro estiver selecionado
        if (this.livroDeRegistro) {
          averbacao.averb_impressa_livro ? this.obterCertificados() : this.direcionaCRUD(false)
        } else {
          this.direcionaCRUD(false)
        }
      },
      async direcionaCRUD (realizarAssinatura = true) {
        if (this.crud === 'store') {
          this.gravarAverbacao(true, realizarAssinatura)

        } else if (this.crud === 'update') {
          this.atualizaAverbacao(realizarAssinatura)

        } else if (this.crud === 'destroy') {
          this.excluirAverbacao(realizarAssinatura)
        }
      },
      excluirAverbacao (realizarAssinatura = true) {
        NProgress.start()
        loader({ text: 'Aguarde...', active: true })

        // Manda pra api de destroy averbacoes
        AverbacoesService.excluirAverbacao(this.averbacaoId).then(async (res) => {
          const response = res.data
          try {
            // Realiza a assinatura
            if (realizarAssinatura && response.documentoLivroDeRegistro) {
              await this.assinaturaAverbacao(response.documentoLivroDeRegistro)
            }

            // Mensagem de sucesso
            objSwal.success.title = "Averbação removida com sucesso!"
            objSwal.success.text = ''
            objSwal.success.html = ''
            await Swal.fire(objSwal.success)
            this.updateList()
          } catch (e) {
            throw e
          }
        })
          .catch(async (error) => {
            const message = getErrors(error)

            return displayMessage('error', 'Erro!', message.message)
          })
          .finally(() => {
            this.crud = null
            this.certificados = null
            this.certificadoSelecionado = null
            this.certificateData = null

            NProgress.done()
            loader({ text: '', active: false })
          })
      },
      async assinaturaAverbacao (documentoLivroDeRegistro) {
        try {
          // Guarda o certificateData para quando assinarmos o Livro de Registro.
          this.certificateData = this.certificadoSelecionado.certificateData

          // Inicia a assinatura
          const iniciaAssinatura = await BryService.startSigning(this.certificateData, documentoLivroDeRegistro.documento_id)

          // Trata o objeto da assinatura
          const assinaturasObj = iniciaAssinatura.assinaturasInicializadas.map(({ nonce, messageDigest }) => {
            return BryService.prepareContentForSignature(messageDigest, nonce)
          })

          const { certId } = this.certificadoSelecionado

          // Digita a senha do certificado
          const { assinaturas } = await BryService.signBase64Content(certId, assinaturasObj)

          // Finaliza a assinatura
          await BryService.endSigning(iniciaAssinatura.nonce, assinaturas)
        } catch (e) {
          /* carregando dados */

          console.error(e)
          throw "Erro ao assinar"
        } finally {
          this.editTextoAverbacao = ''
        }
      },
      async obterCertificados () {
        loader({ text: 'Validando extensão...', active: true })

        if (!BryService.isExtensionInstalled()) {
          loader({ text: '', active: false })

          objSwal.info.title = 'Extensão não instalada'
          objSwal.info.text = 'A extensão para assinatura digital não está instalada no seu navegador. Deseja instalar agora?'
          objSwal.info.html = ''
          objSwal.info.confirmButtonText = 'Instalar'
          objSwal.info.showCancelButton = true
          objSwal.info.cancelButtonText = 'Não'

          return Swal.fire(objSwal.info).then(({ value }) => {
            if (value) {
              try {
                BryService.getExtension()
              } catch (e) {
                this.onLoginError('Erro', e.message)
              } finally {
                this.editTextoAverbacao = ''
              }
            }
          })
        }

        loader({ text: 'Obtendo certificados...', active: true })

        // Retornamos apenas certificados do tipo 'A3'
        const certificados = await BryService.getCertificates()

        this.certificados = certificados.filter(certificate => {
          return certificate.certificateType === 'A3'
        })

        loader({ text: '', active: false })

        if (this.certificados.length === 0) {
          return this.onError('Erro', 'Não foi possível selecionar o certificado. Nenhum certificado foi encontrado')
        }

        if (this.certificados.length > 1) {
          this.$refs.modalCertificados.show()
        } else {
          this.certificadoSelecionado = this.certificados[0]

          // Anulando certificados obtidos
          this.certificados = null

          this.direcionaCRUD()
        }
      },
      /* async obterCertificados () {
        NProgress.start()
        this.$store.dispatch('auth/loader', { text: this.text, active: true }).then(()=> {})

        try {
          await SofiaSignerService.verificaConexao({ force: true })
        } catch (e) {
          objSwal.error.title = ''
          objSwal.error.text = e.message
          return Swal.fire(objSwal.error)
        }

        try {
          this.certificados = await SofiaSignerService.obterCertificados()
        } catch (e) {
          objSwal.error.title = ''
          objSwal.error.text = e.message
          return Swal.fire(objSwal.error)
        }

        if (this.certificados.length > 1) {
          this.$refs.modalCertificados.show()
        } else {
          this.certificadoSelecionado = this.certificados[0]

          // Anulando certificados obtidos
          this.certificados = null

          // Fazendo upload dos arquivos
          this.averbacao()
        }
      }, */
      onSelectCertificado (certificado) {
        this.certificadoSelecionado = certificado

        // Fechando modal
        this.$refs.modalCertificados.hide()

        // Anulando certificados obtidos
        this.certificados = null

        // Fazendo upload dos arquivos
        this.averbacao()
      },
      async autenticarCertificado () {
        let assinatura = null

        try {
          const { posicao } = this.certificadoSelecionado
          const response = await SofiaSignerService.autenticar(posicao)
          assinatura = response.data
        } catch (e) {
          objSwal.error.title = ''
          objSwal.error.text = e.message
          return Swal.fire(objSwal.error)
        }

        if (!assinatura || !assinatura.assinado) {
          objSwal.error.title = ''
          objSwal.error.text = 'Falha na autenticação'
          return Swal.fire(objSwal.error)
        }
      },
      async averbacao () {
        await this.autenticarCertificado()
        AverbacoesService.excluirAverbacao(this.docId).then(() => {
          objSwal.success.title = ''
          objSwal.success.text = 'Averbação excluída com sucesso!'
          Swal.fire(objSwal.success)
        }).catch((error) => {
          objSwal.error.title = ''
          objSwal.error.text = error.response.message
          return Swal.fire(objSwal.error)
        }).finally(() => {
          this.docId = null
          this.updateList()
          NProgress.done()
          this.$store.dispatch('auth/loader', {text: '', active: false})
          return AverbacoesService.getAverbacaoByRegistroId(this.idRegistro.registro_id).then(res => this.averbacoes = res.data)
        })
      }
    },
  }
</script>

<style scoped lang="scss">
  @import '../../../scss/_utilities/exports';

  .cardAverbacao {
    &_title {
      @extend %titleIcon;
      cursor: pointer;

      &:before {
        background-image: url('../../../assets/icons/note.svg');
      }
    }

    &_header {
      margin-bottom: pxToRem(8);

      &_title {
        font-size: pxToRem(12.6);
        font-weight: 500;
        padding: 0;
      }
    }

    &_wrapIcons {
      &_btn {
        border-radius: 50%;
        padding: pxToRem(2) pxToRem(6);
      }

      &_icon {
        position: relative;

        &--iconDelete,
        &--iconEdit {
          @extend .cardAverbacao_wrapIcons_icon;
          fill: $color-white;
        }

        &--iconEdit {}
      }
    }

    &_content {
      border: pxToRem(1) solid $color-dark;
      border-radius: pxToRem(4);
      padding: pxToRem(8) pxToRem(4);

      &_text {
        font-weight: 400;
        font-size: pxToRem(12.6);
        line-height: pxToRem(16);
        padding: pxToRem(4) 0;
      }
    }
  }

  .flag-averb {
    margin: 0px 30px 0px 30px;

    &-disabled {
      color: #c6c6c6;
      fill: #C6C6C6
    }
  }

  .icon-done-averb {
    width: 20px;
    height: 20px;
  }

  .icon-close-averb {
    width: 20px;
    height: 20px;
  }

  .dataAverbacaoGed {
    display: contents;
  }

  .gedIcon {
    width: 43px;
    padding-bottom: 2px;
    margin-right: 40px;
  }
</style>
